import _TabCodes from './TabCodes';
import is from 'is_js';

export default class TabSwitcher {
  static isTabEnabled(state, groupId, tabCode) {
    const group = state.get('rootReducer').get('groups').get(groupId);
    // Let it get api response then do checking
    if (! group || ! group.data) return true;
    const enabledTabCodes = group.data && group.data.enabledModuleCodes;

    // Preserve backward compatibility
    if (is.undefined(enabledTabCodes)) return true;

    return enabledTabCodes.includes(tabCode);
  }
}

TabSwitcher.TabCodes = _TabCodes;

export const TabCodes = _TabCodes;



// WEBPACK FOOTER //
// ./domain/TabSwitcher/index.js